import React from "react";

const SSOLoading = () => {
    return (
        <>
        </>
    )
}

export default React.memo(SSOLoading);